import React, { Component, useState } from 'react';
import { connect } from 'react-redux';
import Actions from '~/Actions';
import {
  Select,
  MenuItem,
  InputBase,
  Button,
  TableRow,
  TableCell,
  TableHead,
  TableContainer,
  TableBody,
  Table,
} from '@material-ui/core';
import { ArrowBackIos, ArrowForwardIos, FirstPage, LastPage } from '@mui/icons-material';

import { EAA_Input, EAA_Select, EAA_Date, EAA_Btn } from '~/components/EditAndAddItem';
import { rightColor, leftColor } from '~/components/EditAndAddItem/common';
import { T_TitleCell, T_TableRow } from '~/components/TableItem';
import PageTitle from '~/components/PageTitle';
import CheckExport from '~/components/Dialog/CheckExport';
import Pick from './Pick';

const Row = ({ children = null }) => <div style={{ marginTop: 16, marginRight: 63, display: 'flex' }}>{children}</div>;
const Item = ({ children = null }) => <div style={{ flex: 1, display: 'flex', alignItems: 'center', marginRight: 16 }}>{children}</div>;
const ItemTitle = ({ text = '', error = false }) => <div style={{ width: 100, display: 'flex', flexDirection: 'row-reverse', paddingRight: 20, fontWeight: 500, color: error ? 'red' : 'black' }}>{text}</div>;

const Btn_Func = ({ value = '', onClick = () => {} }) => {
  const [over, setOver] = useState(false);
  const [over2, setOver2] = useState(false);
  return (
    <Item>
      <ItemTitle text='功能名稱' />
      <div style={{ flex: 1 }}>
        <InputBase
          readOnly
          style={{
            backgroundColor: (over || over2) ? '#f2f2f2' : 'white',
            width: '100%',
            height: 46,
            fontSize: 18,
            letterSpacing: '0.15px',
            borderRadius: '14px 0px 0px 14px',
            paddingLeft: 12,
            paddingRight: 18,
            cursor: 'pointer',
            border: 'solid',
            borderWidth: '1px 0px 1px 1px',
            borderColor: (over || over2) ? 'black' : '#979797',
          }}
          placeholder='請點選按鈕選擇功能名稱'
          inputProps={{ style: { cursor: 'pointer' } }}
          value={value}
          onClick={onClick}
          onMouseOver={() => setOver(true)}
          onMouseOut={() => setOver(false)}
        />
      </div>
      <Button
        style={{
          width: 96,
          height: 46,
          backgroundColor: `#5A397E${(over || over2) ? 'B3' : ''}`,
          borderRadius: '0px 14px 14px 0px',
          border: 'solid',
          borderWidth: '1px 1px 1px 0px',
          borderColor: (over || over2) ? 'black' : '#979797',
          fontSize: 18,
          color: 'white',
          transition: 'none',
        }}
        onClick={onClick}
        onMouseOver={() => setOver2(true)}
        onMouseOut={() => setOver2(false)}
      >
        挑選功能
      </Button>
    </Item>
  );
};

const returnDate = d => `${d.getFullYear()}/${(d.getMonth() + 1) > 9 ? (d.getMonth() + 1) : `0${d.getMonth() + 1}`}/${d.getDate() > 9 ? d.getDate() : `0${d.getDate()}`}`;
class App extends Component {
  constructor (props) {
    super(props);
    this.state = {
      keyword: '',
      start_date: new Date((new Date()).setMonth((new Date()).getMonth() - 3)),
      end_date: new Date(),
      account: '',
      active: '',
      functions: [],
      functionsName: [],
      per_page: 10,
      page: 1,
      sort: true,
      sort_field: 'active_log.add_time',
      view_pick: false,
      dialog_Export: false,
    };
  }

  componentDidMount () {
    const { keyword, account, active, end_date, functions, start_date } = this.state;
    this.data = { keyword, account, active, end_date, functions, start_date };
    this.refresh();
    this.props.getActionList();
    this.props.getAccountList();
  }

  refresh=() => {
    const { page, per_page, sort, sort_field } = this.state;
    const { keyword, account, active, end_date, functions, start_date } = this.data;
    this.props.getNotePageList({
      page,
      per_page,
      body: {
        account,
        active,
        end_date: returnDate(end_date),
        function: functions.toString(),
        keyword,
        sort: sort ? 'desc' : 'asc',
        sort_field,
        start_date: returnDate(start_date),
      },
    });
  }

  _click_search=() => {
    const { openCheckTime } = this.props;
    const { keyword, account, active, end_date, functions, start_date } = this.state;
    this.data = { keyword, account, active, end_date, functions, start_date };
    this.search();
    const error = (start_date.toString().length > 0 && end_date.toString().length > 0) && (start_date > end_date);
    if (error)openCheckTime();
  }

  export=() => {
    const { sort, sort_field } = this.state;
    const { keyword, account, active, end_date, functions, start_date } = this.data;
    const body = {
      account,
      active,
      end_date: returnDate(end_date),
      function: functions.toString(),
      keyword,
      sort: sort ? 'desc' : 'asc',
      sort_field,
      start_date: returnDate(start_date),
    };
    this.props.exportNoteExcel(body);
  }

  search=() => this.setState({ page: 1 }, () => this.refresh());
  _clear=() => {
    this.setState({
      keyword: '',
      start_date: new Date((new Date()).setMonth((new Date()).getMonth() - 3)),
      end_date: new Date(),
      account: '',
      active: '',
      functions: [],
      functionsName: [],
    }, () => this._click_search());
  }

  toolBar=() => {
    const { actionList = [], accountList = [] } = this.props;
    const { keyword, account, active, end_date, functionsName, start_date } = this.state;
    const error = (start_date.toString().length > 0 && end_date.toString().length > 0) && (start_date > end_date);
    return (
      <div style={{ marginTop: 8, display: 'flex', width: '100%', flexDirection: 'column' }}>
        <Row>
          <Item>
            <ItemTitle error={error} text='查詢區間' />
            <EAA_Date displayBorder error={error} value={start_date} onChange={t => this.setState({ start_date: t })} marginRight={0} />
            <div style={{ fontWeight: 400, fontSize: 18, marginRight: 8, marginLeft: 8 }}>～</div>
            <EAA_Date displayBorder error={error} value={end_date} onChange={t => this.setState({ end_date: t })} marginRight={0} />
          </Item>
          <Item>
            <ItemTitle text='操作帳號' />
            <EAA_Select displayBorder defaultItemText='請選擇操作帳號' marginRight={0} list={accountList} value={account} onChange={t => this.setState({ account: t })} />
          </Item>
        </Row>
        <Row>
          <Btn_Func value={functionsName} onClick={() => this.setState({ view_pick: true })} />
          <Item>
            <ItemTitle text='操作項目' />
            <EAA_Select displayBorder defaultItemText='請選擇操作項目' marginRight={0} list={actionList} value={active} onChange={t => this.setState({ active: t })} />
          </Item>
        </Row>
        <Row>
          <Item>
            <ItemTitle text='關鍵字查詢' />
            <EAA_Input displayBorder hint='請輸入關鍵字' value={keyword} onChange={d => this.setState({ keyword: d })} marginRight={0} />
          </Item>
          <Item />
        </Row>
      </div>
    );
  }

  BtnBar=() => (
    <div style={{ width: '100%', display: 'flex', marginTop: 20 }}>
      <div style={{ flex: 1 }} />
      {/* <Button style={{ width: 156, height: 47, backgroundColor: '#B8B8B8', color: 'white', borderRadius: 8, fontSize: 20, fontWeight: 500 }} onClick={this._clear}>清除</Button> */}
      <EAA_Btn text='清除' backgroundColor={leftColor} onClick={this._clear} style={{ width: 156, height: 47, fontSize: 20, fontWeight: 500 }} />
      <EAA_Btn text='查詢' backgroundColor={rightColor} onClick={this._click_search} style={{ width: 156, height: 47, fontSize: 20, fontWeight: 500, marginLeft: 16 }} />
      <div style={{ flex: 1, display: 'flex', flexDirection: 'row-reverse' }}>
        <Button style={{ width: 97, height: 47, backgroundColor: '#5A397E', color: 'white', borderRadius: 5, fontSize: 20, fontWeight: 300, marginRight: 25, marginTop: 10 }} onClick={() => this.setState({ dialog_Export: true })}>
          <svg style={{ marginRight: 7 }} width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.001 3.80938C12.001 3.6125 11.9229 3.42188 11.7823 3.28125L8.72263 0.21875C8.582 0.078125 8.39135 0 8.19134 0H8.00069V4H12.001V3.80938ZM17.8453 9.625L14.8544 6.6125C14.5388 6.29688 13.9981 6.51875 13.9981 6.96562V9H11.9979V11H13.9981V13.0375C13.9981 13.4844 14.5388 13.7063 14.8544 13.3906L17.8453 10.375C18.0516 10.1687 18.0516 9.83125 17.8453 9.625ZM6.00052 10.5V9.5C6.00052 9.225 6.22554 9 6.50056 9H12.001V5H7.75067C7.33814 5 7.00061 4.6625 7.00061 4.25V0H0.750065C0.334404 0 0 0.334375 0 0.75V15.25C0 15.6656 0.334404 16 0.750065 16H11.251C11.6666 16 12.001 15.6656 12.001 15.25V11H6.50056C6.22554 11 6.00052 10.775 6.00052 10.5Z" fill="white" />
          </svg>
          匯出
        </Button>

      </div>
    </div>
  )

  renderTableTitle=() => {
    const { sort, sort_field } = this.state;
    const onChangeSort = t => {
      this.setState({ sort_field: t, sort: sort_field === t ? !sort : false }, () => this.search());
    };
    const ary = [
      { name: '序號' },
      { name: '功能名稱', id: 'function_name' },
      { name: '組織名稱', id: 'active_log.org_name' },
      { name: '操作帳號', id: 'active_log.account' },
      { name: 'IP位址', id: 'active_log.ip' },
      { name: '瀏覽器版本', id: 'active_log.browser_version' },
      { name: '時間', id: 'active_log.add_time' },
      { name: '操作項目' },
    ];
    return (
      <TableHead>
        <TableRow style={{ height: 48 }}>
          {ary.map((o, i) => (
            <T_TitleCell
              key={i}
              text={o.name}
              arrow={!!o.id}
              bol={sort_field === o.id ? sort : true}
              onClick={() => onChangeSort(o.id)}
            />
          ))}
        </TableRow>
      </TableHead>
    );
  }

  renderTableBody=() => {
    const { notePageList = {} } = this.props;
    const { active_list = [], page = 0, total = 0 } = notePageList;
    const { per_page } = this.state;
    const cellStyle = { fontSize: 14 };
    let start = 0;
    if (page > 0) {
      start = (page - 1) * per_page + 1;
      if (start > total)start = 0;
    }
    const returnRecord = t => {
      const ary = [];
      let text = t || '';
      while (text.match('\n')) {
        ary.push(<div key={ary.length}>{text.substring(0, text.indexOf('\n'))}</div>);
        text = text.substring(text.indexOf('\n') + 2);
      }
      ary.push(<div key={ary.length}>{text}</div>);
      return ary;
    };
    return (
      <TableBody>
        {active_list.map((o, i) => (
          <T_TableRow key={i} backgroundColor= {i % 2 === 0 ? '#E0FDFF' : 'white'}>
            <TableCell align='center' style={cellStyle}>{i + start}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.function_name}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.org_name}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.account}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.IP}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.browser_version}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.add_time}</TableCell>
            <TableCell align='left' style={cellStyle}>{returnRecord(o.record)}</TableCell>
          </T_TableRow>
        ))}
      </TableBody>
    );
  }

  renderTableBar=() => {
    const { notePageList = {} } = this.props;
    const { has_next = false, has_prev = false, page = 0, pages = 0, total = 0 } = notePageList;
    const { per_page, page: statePage } = this.state;
    const returnPages = () => {
      const array = [];
      for (let i = 1; i <= pages; i++) {
        array.push(i);
      }
      return array;
    };
    const returnPers = () =>
      // const array = [];
      // for (let i = 5; i <= 15; i++) {
      //   array.push(i);
      // }
      // return array;
      [10, 20, 30, 40]
    ;
    const canFirst = page > 1;
    const canLast = page < pages;
    return (
      <div style={{ height: 48, display: 'flex', alignItems: 'center', width: '98%', backgroundColor: 'white', borderBottomRightRadius: 8, borderBottomLeftRadius: 8, paddingTop: 6, paddingBottom: 6 }}>
        <div style={{ flex: 1 }} />
        <FirstPage style={{ height: 24, width: 24, color: canFirst ? 'black' : 'gray', cursor: canFirst ? 'pointer' : 'default' }} onClick={() => { if (canFirst) this.setState({ page: 1 }, () => this.refresh()); }} />
        <ArrowBackIos style={{ marginLeft: 3, marginRight: 5, height: 16, width: 16, color: has_prev ? 'black' : 'gray', cursor: has_prev ? 'pointer' : 'default' }} onClick={() => { if (has_prev) this.setState({ page: this.state.page - 1 }, () => this.refresh()); }} />
        <div style={{ fontSize: 14 }}>第</div>
        <Select
          style={{ backgroundColor: 'white', height: 36, fontSize: 16, letterSpacing: '0.15px', marginRight: 8, marginLeft: 8 }}
          variant="outlined"
          value={statePage}
          onChange={e => this.setState({ page: e.target.value }, () => { this.refresh(); })}
        >
          {returnPages().map((o, i) => <MenuItem key={i} value={o}>{o}</MenuItem>)}
        </Select>
        <div style={{ fontSize: 14, marginRight: 8 }}>{`/${pages} 頁，每頁`}</div>
        <Select
          style={{ backgroundColor: 'white', height: 36, fontSize: 16, letterSpacing: '0.15px' }}
          variant="outlined"
          value={per_page}
          onChange={e => this.setState({ per_page: e.target.value }, () => { this.search(); })}
        >
          {returnPers().map((o, i) => <MenuItem key={i} value={o}>{o}</MenuItem>)}
        </Select>
        <div style={{ fontSize: 14, marginLeft: 8 }}>{`筆，共${total}筆`}</div>
        <ArrowForwardIos style={{ marginLeft: 5, height: 16, width: 16, color: has_next ? 'black' : 'gray', cursor: has_next ? 'pointer' : 'default' }} onClick={() => { if (has_next) this.setState({ page: this.state.page + 1 }, () => this.refresh()); }} />
        <LastPage style={{ marginRight: 19, height: 24, width: 24, color: canLast ? 'black' : 'gray', cursor: canLast ? 'pointer' : 'default' }} onClick={() => { if (canLast) this.setState({ page: pages }, () => this.refresh()); }} />
        <div style={{ flex: 1 }} />
      </div>
    );
  }

  renderTable=() => {
    const { notePageList = {} } = this.props;
    const { active_list = [] } = notePageList;
    const haveData = active_list.length > 0;
    return (
      <TableContainer style={{ marginTop: 18, maxWidth: '98%' }}>
        <Table style={{ backgroundColor: 'white', borderTopLeftRadius: 8, borderTopRightRadius: 8 }}>
          {this.renderTableTitle()}
          {haveData && this.renderTableBody()}
        </Table>
      </TableContainer>
    );
  }

  render () {
    const { notePageList = {} } = this.props;
    const { total = 0, active_list = [] } = notePageList;
    const { functions, functionsName, view_pick, dialog_Export } = this.state;
    const haveData = active_list.length > 0;
    return (
      <div style={{
        position: 'absolute',
        left: 13,
        right: 0,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        overflow: 'auto',
      }}
      >
        <PageTitle text='日誌管理' />
        {this.toolBar()}
        {this.BtnBar()}
        {this.renderTable()}
        {haveData && this.renderTableBar()}
        {!haveData && <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: 30 }}>尚無資料</div>}
        <Pick open={view_pick} value={functions} nameValue={functionsName} onCancel={() => this.setState({ view_pick: false })} onCheck={(ary, ary2) => this.setState({ functions: ary, functionsName: ary2, view_pick: false }, () => this.search()) } />
        {dialog_Export && <CheckExport num={total} isCsv={true} onExport={this.export} onClose={() => { this.setState({ dialog_Export: false }); }} />}
      </div>
    );
  }
}
const mapStateToProps = state => ({
  actionList: state.data.ActionList,
  accountList: state.data.AccountList,
  notePageList: state.data.NotePageList,
});
const mapDispatchToProps = dispatch => ({
  getActionList: () => Actions.getActionList(dispatch),
  getAccountList: () => Actions.getAccountList(dispatch),
  clearKey: key => Actions.clearKey(dispatch, { key }),
  getNotePageList: body => Actions.getNotePageList(dispatch, body),
  exportNoteExcel: body => Actions.exportNoteExcel(dispatch, { body }),
  openCheckTime: () => Actions.openCheckTime(dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
